import resetPass from './resetPass';

const watchResetPass = [resetPass];

export default watchResetPass;
